import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

export interface RolePagedResponse {
  content: {
    id: string;
    name: string;
    permissionsCount: number;
    usersCount: number;
    creationDate: string;
  }[];
  totalPages: number;
  totalElements: number;
}

export interface RoleResponse {
  id: string;
  name: string;
}

export interface PermissionListResponse {
  permissions: string[];
  count: number;
}

export interface RolePermissionsResponse {
  roleName: string;
  permissions: string[];
  count: number;
}

@Injectable({
  providedIn: 'root'
})
export class RoleService {

  private baseUrl = environment.apiUrl;

  constructor(private http: HttpClient) { }

  // -------------------------------------------
  // PAGINATED ROLES LIST (used in RolesComponent)
  // -------------------------------------------
  getRolesPaged(page: number, size: number): Observable<RolePagedResponse> {
    return this.http.get<RolePagedResponse>(
      `${this.baseUrl}genai-mic/auth/v3/system/list/roles?page=${page}&size=${size}`
    );
  }

  // -------------------------------------------
  // USED FOR SELECT DROPDOWNS
  // -------------------------------------------
  getAllRoles(): Observable<RoleResponse[]> {
    return this.http.get<RoleResponse[]>(`${this.baseUrl}genai-mic/auth/v3/system/list/roles`);
  }

  // -------------------------------------------
  // DELETE ROLE (fixed endpoint)
  // -------------------------------------------
  deleteRole(roleId: string): Observable<any> {
    return this.http.post(
      `${this.baseUrl}genai-mic/auth/v3/system/roles/delete`,
      {
        roleId
      }
    );
  }



  createRole(projectId: string, role: any) {
    return this.http.post<any>(this.baseUrl + "genai-mic/auth/v3/system/project/" + projectId + "/roles", role);
  }

  assignPermissionsBulk(data: any) {
    return this.http.post(`${this.baseUrl}genai-mic/auth/v3/system/permissions/assign/bulk`, data);
  }

  getRolePermissions(roleId: string): Observable<RolePermissionsResponse> {
    return this.http.get<RolePermissionsResponse>(
      this.baseUrl + "genai-mic/auth/v3/system/roles/" + roleId + "/list/permissions"
    );
  }

  getRolesForProject(projectId: string, page: number = 0, size: number = 20) {

    const headers = {
      'X-Project-Id': projectId
    };

    return this.http.get<any>(
      environment.apiUrl + "genai-mic/auth/v3/system/project/" + projectId + "/list/roles?page=" + page + "&size=" + size,
      { headers }
    );
  }


}
